import { taxZapGoogleReviewsLink } from "constants/reviews";

import { useEffect, useMemo, useRef, useState } from "react";

import { Row, Col, Typography } from "antd";
import googleIcon from "assets/images/google.svg";
import quotesLeft from "assets/images/quotes-left-grey.svg";
import quotesRight from "assets/images/quotes-right-grey.svg";
import verfiedIcon from "assets/images/verified.svg";
import { handleResponse } from "services/reviews";
import { Swiper, SwiperSlide } from "swiper/react";
import { IReview } from "types/reviews";

import { getStars } from "../Home/components/getStars";

const Reviews = () => {
    const swiperRef = useRef<any>(null);
    const [reviews, setReviews] = useState<IReview[]>([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const screenSize = useMemo(() => {
        if (windowWidth < 576) return "extraSmall";
        if (windowWidth < 768) return "small";
        if (windowWidth < 992) return "medium";
        if (windowWidth < 1200) return "large";
        return "extraLarge";
    }, [windowWidth]);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        handleResponse().then(response => setReviews(response));
    }, []);

    return (
        <div className="reviews">
            <Swiper
                {...({ slidesPerView: screenSize === "extraSmall" ? 1.1 : screenSize === "small" ? 2 : screenSize === "medium" ? 2.5 : 3 } as any)}
                {...({ spaceBetween: 20 } as any)}
                onSwiper={(swiper: any) => { swiperRef.current = swiper; }}
            >
                {reviews.map((review:IReview, index:number) => (
                    <SwiperSlide key={index}>
                        <div className="reviews__card">
                            <Row justify="space-between" className="w100">
                                <Row className="reviews__card-author">
                                    <img className="reviews__card-author-icon" src={review.icon} alt={review.author}/>
                                    <Typography className="reviews__card-author-name">
                                        {review.author}
                                    </Typography>
                                </Row>
                                <a
                                    href={taxZapGoogleReviewsLink}
                                    className="content-rating-link"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img src={googleIcon} alt="google" width={24} height={24} />
                                </a>
                            </Row>
                            <Row className="mt10">
                                {getStars(review.rating)}
                                <img src={verfiedIcon} alt="verfiedIcon" width={20} height={20} style={{ marginLeft: "10px" }} />
                                <div className="ml6">Verified User</div>
                            </Row>
                            <Col className="reviews__card-content-wrapper">
                                <Row justify="start">
                                    <img src={quotesRight} alt="quotes-right" width={24} height={24}/>
                                </Row>
                                <Typography.Paragraph className="reviews__card-content" ellipsis={{ rows: 4, expandable: true, symbol: "more" }}>
                                    {review.description}
                                </Typography.Paragraph>
                                <Row justify="end">
                                    <img src={quotesLeft} alt="quotes-left" width={24} height={24}/>
                                </Row>
                            </Col>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default Reviews;
